import { CAARepository } from '../repositories/CAARepository'

export function ListDateCAAReport(caaRepositoryAdapter: CAARepository) {
  return async function ({
    patientId,
    date
  }: {
    patientId: string
    date: string
  }) {
    return await caaRepositoryAdapter.listDateCAAReport(patientId, date)
  }
}
